module.exports = __webpack_public_path__ + "static/media/em-104.8d97600b.png";